import styles from "../ChatView.module.scss";

export default function ThreadWelcome() {
  return (
    <div className={styles.welcome}>
      <div className={styles.welcomeMessage}>
        Describe What <br /> You're Looking For
      </div>
    </div>
  );
}
